/* Prosecco Journey — Theme JS v1.1 */

(function () {
  'use strict';

  // ── Cart drawer ──────────────────────────────────────────────────────────
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderCartDrawer(cart));
  }

  let isUpdatingCart = false;

  function changeQty(key, qty) {
    if (isUpdatingCart) {
      console.log('Cart update already in progress, skipping...');
      return;
    }

    console.log('changeQty called:', key, qty);
    isUpdatingCart = true;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [key]: parseInt(qty)
        }
      })
    })
    .then(r => {
      console.log('Response status:', r.status);
      if (!r.ok) {
        return r.text().then(text => {
          console.error('Response body:', text);
          throw new Error('HTTP ' + r.status);
        });
      }
      return r.json();
    })
    .then(data => {
      console.log('Cart update response:', data);
      isUpdatingCart = false;
      refreshCart();
    })
    .catch(err => {
      console.error('Cart update failed:', err);
      isUpdatingCart = false;
    });
  }

  function renderCartDrawer(cart) {
    const itemsEl = document.getElementById('cart-drawer-items');
    const countEl = document.getElementById('cart-drawer-count');
    const subtotalEl = document.getElementById('cart-drawer-subtotal');
    const cartCountBadge = document.querySelectorAll('.cart-count');

    if (!itemsEl) return;

    const count = cart.item_count;
    const subtotal = cart.total_price / 100;
    const FREE_SHIP = 30000;
    const remaining = Math.max(0, FREE_SHIP - subtotal);
    const pct = Math.min(100, (subtotal / FREE_SHIP) * 100);

    if (countEl) {
      const itemText = count === 1
        ? (window.ProseccoJourney?.translations?.cartItemsSingular || '1 bottle')
        : (window.ProseccoJourney?.translations?.cartItemsPlural || count + ' bottles');
      countEl.textContent = itemText.replace(/\{\{\s*count\s*\}\}/, count);
    }
    if (subtotalEl) subtotalEl.textContent = formatHUF(subtotal);
    cartCountBadge.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });

    // Shipping bar
    const shipBar = document.getElementById('cart-ship-bar');
    const shipMsg = document.getElementById('cart-ship-msg');
    if (shipBar) shipBar.style.width = pct + '%';
    if (shipMsg) {
      if (remaining > 0) {
        const progressText = window.ProseccoJourney?.translations?.freeShippingProgress || 'away from free shipping';
        shipMsg.textContent = formatHUF(remaining) + ' ' + progressText;
      } else {
        const unlockedText = window.ProseccoJourney?.translations?.freeShippingUnlocked || '✓ You qualify for free shipping';
        shipMsg.textContent = unlockedText;
      }
    }

    if (cart.items.length === 0) {
      const emptyTitle = window.ProseccoJourney?.translations?.cartEmpty || 'The basket is empty.';
      const emptyBody = window.ProseccoJourney?.translations?.cartEmptyBody || 'Open the cellar to find your bottle.';
      itemsEl.innerHTML = `
        <div style="padding:60px 0;text-align:center;color:var(--fg-3)">
          <div style="font-family:var(--font-display);font-size:28px;color:var(--fg-1);margin-bottom:8px">${emptyTitle}</div>
          <p style="font-family:var(--font-serif);font-style:italic">${emptyBody}</p>
          <a href="/collections/all" class="btn btn--primary" style="margin-top:14px" onclick="closeCart()">Browse the cellar</a>
        </div>`;
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__thumb">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
        </div>
        <div class="cart-item__info">
          <div class="cart-item__vendor">${item.vendor}</div>
          <div class="cart-item__name">${item.product_title}</div>
          <div class="cart-item__actions">
            <div class="qty-stepper" style="margin-top:8px">
              <button type="button" class="qty-minus" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
              <input type="number" value="${item.quantity}" min="0" class="qty-input" data-key="${item.key}" style="width:36px;height:40px;text-align:center;border:0;background:transparent;font-family:var(--font-serif);font-size:16px">
              <button type="button" class="qty-plus" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
            <button type="button" class="qty-remove" data-key="${item.key}" style="font-family:var(--font-sans);font-size:12px;color:var(--fg-3);text-decoration:underline;margin-left:12px">${window.ProseccoJourney?.translations?.cartRemove || 'Remove'}</button>
          </div>
        </div>
        <div class="cart-item__price">${formatHUF(item.final_line_price / 100)}</div>
      </div>
    `).join('');

    // Add event listeners for qty buttons
    itemsEl.querySelectorAll('.qty-minus, .qty-plus').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.dataset.key;
        const qty = parseInt(this.dataset.qty);
        changeQty(key, qty);
      });
    });

    itemsEl.querySelectorAll('.qty-input').forEach(input => {
      input.addEventListener('change', function() {
        const key = this.dataset.key;
        const qty = parseInt(this.value);
        changeQty(key, qty);
      });
    });

    itemsEl.querySelectorAll('.qty-remove').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.dataset.key;
        changeQty(key, 0);
      });
    });
  }

  window.changeQty = changeQty;
  window.openCart = openCart;
  window.closeCart = closeCart;

  // ── Add to cart ──────────────────────────────────────────────────────────
  window.addToCart = function(variantId, qty) {
    qty = qty || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(r => r.json())
    .then(() => { openCart(); showToast('Added to basket'); })
    .catch(() => showToast('Could not add to basket'));
  };

  // ── Product page form ────────────────────────────────────────────────────
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const variantId = productForm.querySelector('[name="id"]').value;
      const qty = parseInt(productForm.querySelector('[name="quantity"]')?.value || 1);
      addToCart(variantId, qty);
    });
  }

  // ── Qty stepper ──────────────────────────────────────────────────────────
  // Egyetlen helyen kezeljük (korábban product-tabs.js és inline scriptek is
  // ráakaszkodtak, így egy kattintás 2-t/3-at léptetett).
  function pjClampQty(input, val) {
    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || Infinity;
    return Math.min(Math.max(isNaN(val) ? min : val, min), max);
  }
  document.querySelectorAll('.js-qty-minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      input.value = pjClampQty(input, parseInt(input.value) - 1);
    });
  });
  document.querySelectorAll('.js-qty-plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      input.value = pjClampQty(input, parseInt(input.value) + 1);
    });
  });

  // ── Product gallery tabs ─────────────────────────────────────────────────
  document.querySelectorAll('.product-gallery__thumb').forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = document.querySelector('.product-gallery__main img');
      if (mainImg) mainImg.src = thumb.querySelector('img').src.replace('_100x', '');
    });
  });

  // ── Product tabs ─────────────────────────────────────────────────────────
  document.querySelectorAll('.product-tabs button').forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;
      document.querySelectorAll('.product-tabs button').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.product-tab-body').forEach(b => b.hidden = true);
      btn.classList.add('active');
      const body = document.querySelector('.product-tab-body[data-tab="' + tab + '"]');
      if (body) body.hidden = false;
    });
  });

  // ── Cart overlay close ───────────────────────────────────────────────────
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.querySelectorAll('[data-close-cart]').forEach(el => el.addEventListener('click', closeCart));
  document.querySelectorAll('[data-open-cart]').forEach(el => el.addEventListener('click', openCart));

  // ── Mobile nav ───────────────────────────────────────────────────────────
  const mobileDrawer = document.getElementById('mobile-drawer');
  const mobileScrim = document.getElementById('mobile-scrim');
  const navBurger = document.querySelector('.nav-burger');
  const mobileClose = document.querySelector('.mobile-close');

  function openMobileNav() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.add('open');
    mobileScrim.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('open');
    mobileScrim.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (navBurger) navBurger.addEventListener('click', openMobileNav);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
  if (mobileScrim) mobileScrim.addEventListener('click', closeMobileNav);

  document.querySelectorAll('.mobile-submenu-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub = btn.nextElementSibling;
      const isOpen = btn.classList.toggle('open');
      if (sub) sub.classList.toggle('open', isOpen);
    });
  });

  // ── Toast ────────────────────────────────────────────────────────────────
  function showToast(msg) {
    const t = document.getElementById('toast');
    if (!t) return;
    t.textContent = '✓ ' + msg;
    t.classList.add('show');
    setTimeout(() => t.classList.remove('show'), 2800);
  }
  window.showToast = showToast;

  // ── Format HUF ───────────────────────────────────────────────────────────
  function formatHUF(n) {
    return new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF', maximumFractionDigits: 0 }).format(n);
  }
  window.formatHUF = formatHUF;

  // ── Collection filter chips ───────────────────────────────────────────────
  document.querySelectorAll('.js-filter-chip').forEach(chip => {
    chip.addEventListener('click', () => {
      chip.classList.toggle('active');
      chip.setAttribute('aria-pressed', chip.classList.contains('active'));
    });
  });

  // ── Newsletter form ───────────────────────────────────────────────────────
  const newsletterForm = document.querySelector('.newsletter__form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', e => {
      e.preventDefault();
      showToast('Thank you — first letter is on its way.');
      newsletterForm.reset();
    });
  }

  // Init cart badge
  fetch('/cart.js').then(r => r.json()).then(cart => {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  });

})();
